import { render } from "./EstadisticasVisitas.vue?vue&type=template&id=1b7a9da6&scoped=true"
import script from "./EstadisticasVisitas.vue?vue&type=script&lang=js"
export * from "./EstadisticasVisitas.vue?vue&type=script&lang=js"

import "./EstadisticasVisitas.vue?vue&type=style&index=0&id=1b7a9da6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7a9da6"]])

export default __exports__